import React from 'react'
import { connect } from 'react-redux'
import { get, keys, sortBy, take, takeRight } from 'lodash'
import Dimensions from 'react-dimensions'
import './index.css'
import StarChart, { StarChartBlock, BLUE_TOPICS } from '../../components/StarChart'
import { setSelectedCountry, setComparisonCountry } from '../../state/actions'
import { continentsColors } from '../../utils'


class MultiStarOverlay extends React.PureComponent {

  componentDidMount(){
    // const node = ReactDOM.findDOMNode(this)
    // node.scrollIntoView(true)
    window.scrollTo(0, 0)
  }

  render(){
    const { divStyle,  handleSelectCountry, selectedCountry, comparisonCountry,
      latestDataByIndicator, tfaArticles, focusedOptions } = this.props
    return (
      <div className="MultiStarChart__chart_container" style={divStyle} onClick={handleSelectCountry(null)}>
        <div className="MultiStarChart__overlay border-blue">
          <div className={`${comparisonCountry ? 'MultiStarChart__overlay__box--double' : 'MultiStarChart__overlay__box'}`}
            onClick={(e)=> { e.stopPropagation()}}>
            <StarChart latestDataByIndicator={latestDataByIndicator} tfaArticles={tfaArticles} countryCode={selectedCountry} focusedOptions={focusedOptions}/>
          </div>
          {(comparisonCountry !== null) && (
            <div className="MultiStarChart__overlay__box--double" onClick={(e)=> { e.stopPropagation()}}>
              <StarChart latestDataByIndicator={latestDataByIndicator} tfaArticles={tfaArticles} countryCode={comparisonCountry} focusedOptions={focusedOptions}/>
            </div>
          )}
        </div>
      </div>
    )
  }

}





class MultiStarChart extends React.PureComponent {

  getFillOpacity(d, scale){
    const { emptyFill, dataMap } = this.props
    if(dataMap[d.id]){
      const out = scale(dataMap[d.id])
      return out
    }
    return emptyFill ? 1 : 0
  }

  handleSelectCountry = (countryCode) => (e) => {
    this.props.setSelectedCountry(countryCode)
    if(countryCode === null){
        this.props.setComparisonCountry(null)
    }
  }

  render() {
    const { countries,
      latestDataByIndicator, tfaArticles,
      borderColor='#0D66A5',
      containerWidth, itemSize=100, itemMargin=5, labelheight=10,
      selectedCountry, comparisonCountry, colorMode, countryMode,
      countriesContinents, focusedOptions } = this.props

    let countryCodes = keys(countries).sort()

    // filtering empty records and annotating for sorting
    let sortMap = {}
    countryCodes = countryCodes.filter(code => {
      // console.log("latestDataByIndicator", latestDataByIndicator)
      let tfaValues = []
      const hasTfa = keys(tfaArticles).reduce((acc, item)=>{
        const hasTfaArticle = get(tfaArticles[item], `[${code}].v`)
        hasTfaArticle && tfaValues.push(hasTfaArticle)
        return acc || hasTfaArticle
      }, false)

      let indicatorValues = []
      const hasIndicators = BLUE_TOPICS.reduce((acc, item)=>{
        const hasIndicator = get(latestDataByIndicator[item], `[${code}].v`)
        hasIndicator && indicatorValues.push(hasIndicator)
        return acc || hasIndicator
      }, false)

      return hasTfa || hasIndicators
    })

    // if(countryMode === 'top' || countryMode === 'bottom'){
    //   const annotatedByETI = sortBy(
    //     keys(latestDataByIndicator['ETI'])
    //     .filter(key => get(latestDataByIndicator['ETI'][key], 'v'))
    //     .map(key => {
    //       return { code: key, value: latestDataByIndicator['ETI'][key].v}
    //     }), item => item.value).map(item => item.code)
    //
    //   if(countryMode === 'top'){
    //     countryCodes = takeRight(annotatedByETI, 25)
    //   }
    //
    //   if(countryMode === 'bottom'){
    //     countryCodes = take(annotatedByETI, 25)
    //   }
    // }

    const itemWidth = itemSize + ( itemMargin * 2 )
    const itemHeight = itemSize + ( itemMargin * 2 ) + labelheight
    const itemsPerRow = Math.floor(containerWidth / itemWidth)
    const numRows = Math.ceil(countryCodes.length / itemsPerRow)

    let dataRows = []
    for(let i=0;i<numRows; i++){
      let row = []
      for (let j=0; j<itemsPerRow; j++){
        const idx = i * itemsPerRow + j;
        if(idx <= countryCodes.length){
          row.push(countryCodes[idx])
        }
      }
      dataRows.push(row)
    }

    const divStyle = {width: containerWidth, height: itemHeight * (numRows + 1)}

    const overlayProps = {
        divStyle,
        handleSelectCountry:this.handleSelectCountry,
        selectedCountry, comparisonCountry, latestDataByIndicator,
        tfaArticles, focusedOptions
    }

    const svgWidth = itemWidth*itemsPerRow

    return (
      <div style={divStyle}>

        {(selectedCountry !== null) && <MultiStarOverlay {...overlayProps} />}

        <svg className="MultiStarChart__svg" style={{borderColor:borderColor, margin: `0 ${(containerWidth-svgWidth)/2}`}}

          width={svgWidth} height={itemHeight*numRows}>
          <g>
            { dataRows.map((row, i) => (
              <g  key={i} transform={`translate(0, ${i*itemHeight})`}>
                { row.map((countryCode, j) => {
                  let inlineColor = null;
                  if (colorMode === 'continent'){
                    inlineColor = continentsColors[countriesContinents[countryCode]];
                  }

                  return (
                    <g key={j}>
                      <g transform={`translate(${j*itemWidth}, 0)`}>
                        <rect onClick={ this.handleSelectCountry(countryCode) } className="MultiStarChart__element" y={itemMargin} x={itemMargin} width={itemWidth} height={itemHeight}></rect>
                        <g transform={`translate(${itemMargin}, 0)`}>
                        <StarChartBlock containerWidth={itemWidth} inlineColor={inlineColor} latestDataByIndicator={latestDataByIndicator} tfaArticles={tfaArticles} countryCode={countryCode}/>
                        </g>
                        <text onClick={ this.handleSelectCountry(countryCode) } className="MultiStarChart__label" x={itemWidth/2} y={itemSize + labelheight/2}>{countryCode}</text>
                      </g>
                    </g>
                  )
                }
              )}
              </g>
            ))}
          </g>
        </svg>
      </div>
    )
  }
}


const mapStateToProps = (state, props) => ({
  countries: state.countries,
  countriesContinents: state.countriesContinents,
  selectedCountry: state.selectedCountry,
  comparisonCountry: state.comparisonCountry,
  colorMode: state.colorMode,
  countryMode: state.countryMode,
})

const mapDispatchToProps = { setSelectedCountry, setComparisonCountry }

export default connect(mapStateToProps, mapDispatchToProps)(Dimensions()(MultiStarChart))



// WEBPACK FOOTER //
// ./src/components/MultiStarChart/index.js